<template lang="">
  <div>
    <!-- <login v-if="!login" @login="logins"></login>
    <home v-if="login"></home> -->
    <router-view></router-view>
  </div>
</template>
<script>
import login from "./components/login";
import home from "./components/home";
import { token } from "./api/index.js";

export default {
  data() {
    return {
      login: false,
    };
  },
  components: {
    login,
    home,
  },
  mounted() {
    window.Notice = this.$Notice;
    // var storage = window.localStorage;
    // const randcode = localStorage.getItem("token");  本地存储
    const randcode = sessionStorage.getItem("JigGyrBuasd"); //会话存储
    if (randcode === null) {
      this.$router.push("/login");
    } else {
      // 验证登录状态
      token({
        key: randcode,
      }).then((res) => {
        // 存在时验证是否合法
        if (res.success == true) {
          // if (this._isMobile()) {
          //   this.$router.replace("/mobile");
          // } else {
          //   this.$router.push("/");
          // }
            this.$router.push("/");
        } else {
          this.$router.push("/login");
        }
      });
    }
  },
  methods: {
    _isMobile() {
      let flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      );
      return flag;
    },
    logins(e) {
      if (e) {
        this.login = true;
      }
    },
  },
};
</script>
<style lang="less"></style>
